import { FC } from 'react';
import styled from 'styled-components';
import { CustomerLogo, CustomerLogoProps } from '@cld/customer-logo';
import { CLD_LOGO_SRC } from '../../ApplicationWrapper.const';

export const CloudLogo: FC<CustomerLogoProps> = ({ src, ...rest }) => (
  <StyledCustomerLogo data-testid="cloudlogo" src={src} fallback={CLD_LOGO_SRC} size="md" {...rest} />
);

const StyledCustomerLogo = styled(CustomerLogo)`
  margin-bottom: ${(props) => props.theme.spacing.xxs};
  background-color: transparent;
`;
